import * as React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
const DestinationPermissionAlert = ({ section }) => {
  const { t } = useTranslation("streams");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, t(`destination_permission_alert.${section}`));
};
export default DestinationPermissionAlert;
